import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { volumes } from '../data/volumes';
export function VolumesSection() {
  return <section className="py-24 px-4 bg-[#F5F7FB]" data-id="element-270" data-mp="coiu4r4d9dov">
      <div className="max-w-6xl mx-auto" data-id="element-271" data-mp="cn7t2z2b2k1g">
        <div className="text-center mb-16" data-id="element-272" data-mp="cm4yoh5rxzgs">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-4 text-[#081632]" data-id="element-273" data-mp="7qhe6f28luhm">
            📚 THE 6-IN-1 JUDO COACH READY SYSTEM
          </h2>
          <p className="text-xl text-[#081632]/75" data-id="element-274" data-mp="3g2vflr2w9wx9">
            <span className="text-[#D89B16] font-semibold" data-id="element-275" data-mp="3c4xlc9u9okn0">150 ready-to-coach sessions</span> ·
            Beginner to advanced · Visual coaching tools · Nothing to build from scratch
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-276" data-mp="3l2rito3rpkbr">
          {volumes.map((volume, index) => <motion.article key={volume.number} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-white rounded-2xl border ${volume.popular ? 'border-[#D89B16] shadow-lg shadow-[#1E4ED8]/15' : 'border-[#D89B16]/40 shadow-sm shadow-[#1E4ED8]/10'} p-8 relative overflow-hidden flex flex-col h-full`} data-id="element-277" data-mp="2xd5k11rb574a" data-mpi={index}>
              {volume.popular && <div className="absolute top-6 right-[-38px] bg-[#D89B16] text-[#081632] font-bold text-xs py-1 px-10 rotate-45 shadow" data-id="element-278" data-mp="1vfpr77cqq61j">
                  ⭐ MOST POPULAR
                </div>}

              <div className="flex items-center gap-4 mb-6" data-id="element-279" data-mp="24g5ry923mz2p">
                <span className="text-4xl" aria-hidden="true" data-id="element-280" data-mp="24hqmhyoeyi0k">
                  {volume.icon}
                </span>
                <div data-id="element-281" data-mp="3bwbrny027axi">
                  <div className="text-[#1E4ED8] font-bold text-sm uppercase tracking-wider" data-id="element-282" data-mp="3fvayjo5cphrl">
                    {volume.number}
                  </div>
                  <h3 className="text-2xl font-serif font-bold leading-tight mt-1 text-[#081632]" data-id="element-283" data-mp="1gozqphaelhrg">
                    {volume.title}
                  </h3>
                </div>
              </div>

              <p className="text-[#081632]/75 font-medium mb-6 italic border-l-2 border-[#D89B16] pl-4" data-id="element-284" data-mp="1pqprveu37v2f">
                {volume.subtitle}
              </p>

              <div className="mb-6 space-y-2" data-id="element-285" data-mp="x222b72b2jj2">
                <h4 className="text-sm font-bold text-slate-500 uppercase tracking-wider mb-2" data-id="element-286" data-mp="x0qxr511d7qw">
                  What does this solve for your coaching?
                </h4>
                {volume.problem.map(paragraph => <p key={paragraph} className="text-slate-700 text-sm leading-relaxed" data-id="element-287" data-mp="1226kr2mrxobx">
                    {paragraph}
                  </p>)}
                {volume.chain && <p className="text-[#1E4ED8] font-bold text-sm bg-[#F5F7FB] border border-[#1E4ED8]/20 rounded-lg px-3 py-2" data-id="element-288" data-mp="9disuo7is0pe">
                    {volume.chain}
                  </p>}
                {volume.afterChain?.map(paragraph => <p key={paragraph} className="text-slate-700 text-sm leading-relaxed" data-id="element-289" data-mp="2psm5lbtdeu5v">
                    {paragraph}
                  </p>)}
              </div>

              {volume.bulletsIntro && <p className="text-[#081632] font-semibold text-sm mb-3" data-id="element-290" data-mp="2gwmw5kqfu2pf">{volume.bulletsIntro}</p>}

              <ul className={`mb-6 flex-grow ${volume.bullets.length > 10 ? 'grid sm:grid-cols-2 gap-x-4 gap-y-3 content-start' : 'space-y-3'}`} data-id="element-291" data-mp="38px58xiwzplu">
                {volume.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-292" data-mp="1jbimquyhoyys">
                    <CheckCircle2 size={18} className="text-[#D89B16] shrink-0 mt-0.5" data-id="element-293" data-mp="1jdlky29spyel" />
                    <span className="text-slate-700 text-sm" data-id="element-294" data-mp="1o88y54zcn6dv">{bullet}</span>
                  </li>)}
              </ul>

              {volume.afterBullets && <p className="text-[#081632] font-medium text-sm italic mb-6" data-id="element-295" data-mp="1yrp9p2xzkomw">{volume.afterBullets}</p>}

              <div className="bg-[#F5F7FB] border border-[#D89B16]/40 rounded-xl p-4 mt-auto" data-id="element-296" data-mp="1upkieav0g43f">
                <span className="text-[#081632] font-bold block mb-1" data-id="element-297" data-mp="1puex9e9fmtge">Result:</span>
                <p className="text-slate-700 text-sm" data-id="element-298" data-mp="2mib6fy2jimhl">{volume.result}</p>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}